module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/sign-up-image-87ddd37e871d88853c3dfb103c33c173.png";